<template>
  <div>
    <div class="news-card" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
     
      <div class="u-flex-col justify-between" style="height: 100%; flex: 1;">
        <div class="flxx">
          <span class="theme u-line-3">{{item.informantName}}</span>
        </div>
        <div class="justify-between" style="display: flex; align-items: center; margin-top: 8px">
          <span class="dz">{{item.audit_dictText}}</span>
          <span class="time">{{item.createTime}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    // 自定义返回逻辑
    clickItem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listData: [],
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    goDetail(e){
      this.$router.push({
          path: '/hmhq/problem-hyb-view',
          query: { id: e.id },
        })
    },
  },
}
</script>

<style lang="less">
.news-card {
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  display: flex;
  padding: 12px 10px;
  position: relative;

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .flxx{
    display: flex;
    align-items: center;
  }
  .ry{
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
  .img {
    width: 64px;
    height: 64px;
    margin-right: 10px;
  }

  .theme {
    font-size: 15px;
    font-weight: 400;
    color: #303133;
  }

  .time {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
    margin-left: auto;
  }

  .dz {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
}

	.jiaobiao{width: 80px; height: 80px; background: #99adc2; color: #fff; display: flex; align-items: flex-end; transform: rotate(45deg); -webkit-transform: rotate(45deg); position: absolute; font-size: 12px; top: -48px; right: -48px; justify-content: center;}
	.jiaobiao font{position: relative; top: 2px; letter-spacing: 1px;}
</style>
